import React, { createContext, useContext } from "react";
import useFilterController from "./useFilterController";

const FilterControllerContext = createContext(null);

export function FilterControllerProvider({ children, ...filterProps }) {
  const controller = useFilterController(filterProps);
  return (
    <FilterControllerContext.Provider value={controller}>
      {children}
    </FilterControllerContext.Provider>
  );
}

export function useFilterControllerContext() {
  return useContext(FilterControllerContext);
}
